import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import api from "./api";
import { ForgotPage, LoginPage, ResetPage } from "./AuthPages";
import Layout from "./Layout";
import Home from "./Home";
import FlowList from "./FlowList";
import CaseDetail from "./CaseDetail";
import Vendors from "./Vendors";
import Users from "./Users";
import Tds from "./Tds";
import AuditLog from "./AuditLog";
import Products from "./Products";
import SettingsPage from "./SettingsPage";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

const FullPageLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-[#F9F8F6]">
    <p className="text-sm uppercase tracking-[0.25em] text-[#8A9A91]">Loading…</p>
  </div>
);

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <FullPageLoader />;
  if (user === false) return <Navigate to="/qc/login" replace />;
  return children;
};

export default function QcApp() {
  const [user, setUser] = useState(null);

  const refresh = () =>
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));

  useEffect(() => {
    if (!localStorage.getItem("snf_qc_token")) {
      setUser(false);
      return;
    }
    refresh();
  }, []);

  const logout = () => {
    localStorage.removeItem("snf_qc_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, logout, refresh }}>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route path="forgot" element={<ForgotPage />} />
        <Route path="reset/:token" element={<ResetPage />} />
        <Route
          element={
            <Protected>
              <Layout />
            </Protected>
          }
        >
          <Route index element={<Navigate to="home" replace />} />
          <Route path="home" element={<Home />} />
          <Route path="invoicing" element={<FlowList />} />
          <Route path="invoicing/:flow" element={<FlowList />} />
          <Route path="cases/:id" element={<CaseDetail />} />
          <Route path="vendors" element={<Vendors />} />
          <Route path="users" element={<Users />} />
          <Route path="tds" element={<Tds />} />
          <Route path="audit" element={<AuditLog />} />
          <Route path="products" element={<Products />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/qc/home" replace />} />
      </Routes>
    </AuthCtx.Provider>
  );
}
